import { RPCDocs, RPCs } from "../../../services/rpc.js";
import { useRPC } from "../../../hooks/useRPC/index.js";
//#region src/modules/Records/hooks/useRecords.ts
var testData = {
	records: [
		{
			comments: 0,
			description: "Jeff Robert, Alias: Spicy, Male, Bispanic or Latino, Ht: 5'11, Wt: 180",
			id: "record-2772c95c-b663-4d64-b29d-b78ffa7508b7",
			imageUrl: "https://therms.s3-us-west-2.amazonaws.com/images/record-person-placeholder.png",
			labels: [
				{
					category: "records",
					color: "#708090",
					id: "tag-4c800d80-7b82-4526-b678-1dfe8e28ce6e",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Combative"
				},
				{
					category: "records",
					color: "#FE6F5E",
					id: "tag-2850f73b-38b4-4848-a51d-2a3dafc792b0",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Dangerous"
				},
				{
					category: "records",
					color: "#b42525",
					id: "tag-0cf0b6e9-5534-491a-aeee-e975cb373c44",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Psycho"
				},
				{
					category: "records",
					color: "#FFA000",
					id: "tag-574f7b4e-5479-43fc-a538-c1957574f4bf",
					level: 3,
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Mental Illness"
				}
			],
			lastActivity: "2021-12-27T04:59:12.068Z",
			primaryImageUrl: "https://therms.s3-us-west-2.amazonaws.com/images/record-person-placeholder.png",
			regionIds: ["rgn-"],
			tags: [
				{
					category: "records",
					color: "#708090",
					id: "tag-4c800d80-7b82-4526-b678-1dfe8e28ce6e",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Combative"
				},
				{
					category: "records",
					color: "#FE6F5E",
					id: "tag-2850f73b-38b4-4848-a51d-2a3dafc792b0",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Dangerous"
				},
				{
					category: "records",
					color: "#b42525",
					id: "tag-0cf0b6e9-5534-491a-aeee-e975cb373c44",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Psycho"
				},
				{
					category: "records",
					color: "#FFA000",
					id: "tag-574f7b4e-5479-43fc-a538-c1957574f4bf",
					level: 3,
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Mental Illness"
				}
			],
			title: "Jeff Robert",
			type: RPCDocs.Records.GetRecordsList.v1.TypeFilter.Person
		},
		{
			comments: 11,
			description: "Person 1, Alias: Spicy, male, white, Ht: 5'11, Wt: 180",
			id: "record-4a5c3767-9f3c-49ce-8fd7-04b180c8e53c",
			imageUrl: "https://therms-files.s3.amazonaws.com/5fc81c8648b2f64b9a6cbdb8.jpg",
			labels: [
				{
					category: "records",
					color: "#FE6F5E",
					id: "tag-2850f73b-38b4-4848-a51d-2a3dafc792b0",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Dangerous"
				},
				{
					category: "records",
					color: "#FFA000",
					id: "tag-574f7b4e-5479-43fc-a538-c1957574f4bf",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Mental Illness"
				},
				{
					category: "records",
					color: "#b42525",
					id: "tag-0cf0b6e9-5534-491a-aeee-e975cb373c44",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Psycho"
				}
			],
			lastActivity: "2021-11-24T20:49:18.275Z",
			primaryImageUrl: "https://therms-files.s3.amazonaws.com/5fc81c8648b2f64b9a6cbdb8.jpg",
			regionIds: ["rgn-"],
			tags: [
				{
					category: "records",
					color: "#FE6F5E",
					id: "tag-2850f73b-38b4-4848-a51d-2a3dafc792b0",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Dangerous"
				},
				{
					category: "records",
					color: "#FFA000",
					id: "tag-574f7b4e-5479-43fc-a538-c1957574f4bf",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Mental Illness"
				},
				{
					category: "records",
					color: "#b42525",
					id: "tag-0cf0b6e9-5534-491a-aeee-e975cb373c44",
					organizationId: "organization-92be7fc9-7d08-4fe5-a3b9-3432c1abc63e",
					title: "Psycho"
				}
			],
			title: "Person 1",
			type: RPCDocs.Records.GetRecordsList.v1.TypeFilter.Person
		},
		{
			comments: 0,
			description: "Cory",
			id: "record-ec91d649-8c40-4782-9fba-ebd2746be170",
			imageUrl: "https://therms.s3-us-west-2.amazonaws.com/images/record-person-placeholder.png",
			labels: [],
			lastActivity: "2021-11-02T18:10:17.328Z",
			primaryImageUrl: "https://therms.s3-us-west-2.amazonaws.com/images/record-person-placeholder.png",
			regionIds: ["rgn-"],
			tags: [],
			title: "Cory",
			type: RPCDocs.Records.GetRecordsList.v1.TypeFilter.Person
		}
	],
	total: 3
};
function useRecords(args, opts = {}) {
	const { call, data, isCalling } = useRPC(RPCs.Records.GetRecordsList.v1, args, {
		cacheStrategy: opts.cacheStrategy,
		fire: !!args,
		testData
	});
	return {
		data,
		loading: isCalling,
		refresh: call
	};
}
//#endregion
export { useRecords };

//# sourceMappingURL=useRecords.js.map